import { render, staticRenderFns } from "./user_popup.vue?vue&type=template&id=1588f5f4"
import script from "./user_popup.vue?vue&type=script&lang=js"
export * from "./user_popup.vue?vue&type=script&lang=js"
import style0 from "./user_popup.vue?vue&type=style&index=0&id=1588f5f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports